import { motion } from 'framer-motion';

export function SectionLabel({ children, testid }) {
  return (
    <motion.p
      data-testid={testid}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="text-xs sm:text-sm font-semibold uppercase tracking-[0.28em] text-[#8a8a8a] flex items-center gap-3"
    >
      <span className="w-8 h-px bg-[#e8173a]" />
      {children}
    </motion.p>
  );
}

export function Reveal({ children, delay = 0, className = '', y = 36 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
